import { useCategoryInventory } from 'hooks/InventoryHooks/useCategoryInventory';
import React from 'react';
import CategoriesList from '@rahtab/system/lib/screens/CategoriesList';
import { StackScreenProps } from '@rahtab/stack-navigator';
import { RootStackType } from 'components/Router';

type StoreInventoryProps = StackScreenProps<RootStackType, 'StoreInventory'>;

const StoreInventory: React.VFC<StoreInventoryProps> = (props) => {
  const { providerCode } = props.route.params;
  const { called, loading, data, refetchInventory } = useCategoryInventory({ providerCode });
  return (
    <CategoriesList
      screenTitle="موجودی فروشگاه"
      loading={loading}
      listData={data.map((category) => {
        return {
          id: category.id,
          image: category.imageUrl,
          name: category.name,
          merchandiseCount: category.merchandiseCount,
          statusText: category.statusText,
          status: category.status,
        };
      })}
      refreshing={called && loading}
      onRefresh={refetchInventory}
      screenName={'MerchandiseInventory'}
      providerCode={providerCode}
    />
  );
};
export default StoreInventory;
